(function () {
    var blocks = document.querySelectorAll('.all-faqs');

    function setPanelHeight(item, open) {
        var panel = item.querySelector('[data-acc-panel]');
        if (!panel) return;
        panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '0px';
    }

    blocks.forEach(function (block) {
        var cats = block.querySelectorAll('.all-faqs__cat');
        var groups = block.querySelectorAll('.all-faqs__group');

        var track = block.querySelector('.all-faqs__cats');
        var mq = window.matchMedia('(max-width: 767px)');
        var isMobile = function () { return mq.matches; };

        function ensureInitialOrder() {
            if (track && !track._initial) track._initial = Array.from(track.children);
        }
        function restoreDesktopOrder() {
            if (!track || !track._initial) return;
            track._initial.forEach(function (el) { track.appendChild(el); });
        }
        function putActiveFirst() {
            if (!track) return;
            var active = track.querySelector('.all-faqs__cat.is-active');
            if (!active) return;

            var listRect = track.getBoundingClientRect();
            var itemRect = active.getBoundingClientRect();

            var delta = itemRect.left - listRect.left;

            var extraPadding = 0;

            var targetScroll = track.scrollLeft + delta - extraPadding;

            track.scrollTo({
                left: targetScroll,
                behavior: 'smooth'
            });
        }
        function applyLayout() {
            ensureInitialOrder();
            if (isMobile()) putActiveFirst();
            else restoreDesktopOrder();
        }

        function clearPrevBorder(group) {
            var prevMarked = group.querySelector('.faq-item--prev-of-open');
            if (prevMarked) prevMarked.classList.remove('faq-item--prev-of-open');
        }

        function activate(termId) {
            cats.forEach(function (b) {
                var on = b.getAttribute('data-term') === termId;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            groups.forEach(function (g) {
                var on = g.getAttribute('data-term') === termId;
                g.classList.toggle('is-active', on);
                if (on) {
                    clearPrevBorder(g);
                    g.querySelectorAll('[data-accordion]').forEach(function (it) {
                        it.classList.remove('is-open');
                        setPanelHeight(it, false);
                    });
                }
            });

            if (isMobile()) putActiveFirst(); else restoreDesktopOrder();
        }

        var initial = block.getAttribute('data-initial-term') || (cats[0] && cats[0].getAttribute('data-term'));
        if (initial) activate(initial);

        cats.forEach(function (btn) {
            btn.addEventListener('click', function () {
                activate(btn.getAttribute('data-term'));
            });
        });

        block.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-acc-btn]');
            if (!btn) return;
            var item = btn.closest('[data-accordion]');
            var group = item && item.parentElement;
            if (!item || !group) return;

            var willOpen = !item.classList.contains('is-open');

            group.querySelectorAll('[data-accordion].is-open').forEach(function (el) {
                if (el !== item) {
                    el.classList.remove('is-open');
                    setPanelHeight(el, false);
                }
            });

            item.classList.toggle('is-open', willOpen);
            setPanelHeight(item, willOpen);

            clearPrevBorder(group);
            if (willOpen) {
                var prev = item.previousElementSibling;
                if (prev && prev.classList && prev.classList.contains('faq-item')) {
                    prev.classList.add('faq-item--prev-of-open');
                }
            }
        });

        window.addEventListener('resize', function () {
            block.querySelectorAll('[data-accordion].is-open').forEach(function (item) {
                setPanelHeight(item, true);
            });
            applyLayout();
        });

        if (mq.addEventListener) mq.addEventListener('change', applyLayout);
        else mq.addListener(applyLayout);

        applyLayout();
    });
})();
